import { Coins } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useCurrency } from "@/hooks/use-currency";
import { DISPLAY_CURRENCY_CODES, getCurrency } from "@/lib/currency";
import { cn } from "@/lib/utils";

interface CurrencySelectorProps {
  className?: string;
  showLabel?: boolean;
}

/** Global display-currency picker. Changes reference display only, never stored prices. */
export function CurrencySelector({ className, showLabel = true }: CurrencySelectorProps) {
  const { displayCurrency, setDisplayCurrency } = useCurrency();
  const active = getCurrency(displayCurrency);

  return (
    <Select value={displayCurrency} onValueChange={setDisplayCurrency}>
      <SelectTrigger className={cn("h-9 w-auto gap-2", className)} aria-label="Display currency">
        <Coins className="h-4 w-4 text-muted-foreground" />
        <SelectValue>
          {showLabel ? `${active.code} (${active.symbol})` : active.code}
        </SelectValue>
      </SelectTrigger>
      <SelectContent className="max-h-72">
        {DISPLAY_CURRENCY_CODES.map((code) => {
          const c = getCurrency(code);
          return (
            <SelectItem key={code} value={code}>
              {c.symbol} {c.code} — {c.name}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}